


















import { computed, defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ProgressConstants } from '../constants/progress.constants';
import router from '../../router/router';
import { useTemplateGalleryStore } from '../store/template-gallery.store';

export default defineComponent({
  components: {},
  props: {
    templateId: { type: String, default: '' },
  },
  setup(props, { emit }) {
    const templateGalleryStore = useTemplateGalleryStore();
    const progress = ref(0);
    const hasNewTemplate = computed(() => templateGalleryStore.newTemplateId !== '');

    const startProgress = () => {
      setTimeout(() => {
        if (progress.value === 90) {
          return;
        }
        progress.value++;
        startProgress();
      }, 100);
    };

    onMounted(() => {
      templateGalleryStore.copy(props.templateId);
      startProgress();
    });

    watch(
      () => hasNewTemplate.value,
      () => {
        emit('close');
        progress.value = ProgressConstants.maxProgress;
        router.push({ name: PathName.ContentLibrary });
      }
    );

    return {
      progress,
      t,
    };
  },
});
